export default "__VITE_ASSET__CkcIiyiu__"